import React, { useState } from "react"
import { useDispatch } from "react-redux"
import CustomImage from "@/main/customImage"
import {
    EmailShareButton,
    TwitterShareButton,
    FacebookShareButton,
    FacebookMessengerShareButton,
    WhatsappShareButton,
} from "react-share"
import {
    EmailIcon,
    TwitterIcon,
    FacebookIcon,
    FacebookMessengerIcon,
    WhatsappIcon,
} from "react-share"

import {
    toggleRequestViewingModal,
    setRequestViewingProperty,
} from "@/slices/requestViewingModalSlice"

import { Row, Col, Card, Button, Toast } from "react-bootstrap"

function PropertySummary({ property }) {
    const dispatch = useDispatch()

    const [showShare, setShowShare] = useState(false)

    const toggleShowShare = () => setShowShare(!showShare)

    const formatter = new Intl.NumberFormat("en", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 0,
    })

    return (
        /* Property Summary */
        <Col xs={12} lg={5} className="p-0 mt-lg-5 mt-xl-6 mt-xxl-7">
            <Card.Body>
                <Row className="justify-content-between">
                    <Col xs="auto">
                        <span className="mb-2">
                            {property.trans_type_id === 1 &&
                                property.residential_sales_details &&
                                property.residential_sales_details
                                    ?.price_qualifier !== "None" && (
                                    <>
                                        {
                                            property.residential_sales_details
                                                ?.price_qualifier
                                        }
                                        &nbsp; &nbsp; | &nbsp; &nbsp;
                                    </>
                                )}
                            {property.property_ref}
                        </span>
                    </Col>

                    {property.status_id === 1 ? (
                        <Col xs="auto" className="me-2 bg-danger">
                            <span className="text-white">Sold STC</span>
                        </Col>
                    ) : property.status_id === 5 ? (
                        <Col xs="auto" className="me-2 bg-danger">
                            <span className="text-white">Let agreed</span>
                        </Col>
                    ) : null}
                </Row>

                <span className="h3 d-flex mb-3">
                    {formatter.format(property.price)}
                    {property.trans_type_id === 2 &&
                    property.residential_lettings_details
                        ?.let_rent_frequency === 0
                        ? " pw"
                        : property.residential_lettings_details
                                ?.let_rent_frequency === 1
                          ? " pcm"
                          : property.residential_lettings_details
                                  ?.let_rent_frequency === 2
                            ? " per Quarter"
                            : property.residential_lettings_details
                                    ?.let_rent_frequency === 3
                              ? " pa"
                              : ""}
                </span>
                <h2 className="h4 mb-3">{property.display_address}</h2>
                <div className="d-flex mb-4">
                    <div>
                        <span className="me-1 align-text-center">
                            <CustomImage
                                src={
                                    "https://webb-jenkins-static-164679926.imgix.net/icons/bed.svg"
                                }
                                alt="Bed icon"
                                height={16}
                                width={24}
                            />
                        </span>

                        <span className="align-text-center me-5">
                            {property.bedrooms} Bedroom
                            {property.bedrooms > 1 && "s"}
                        </span>
                    </div>

                    {property.bathrooms > 0 && (
                        <div>
                            <span className="align-text-center">
                                <CustomImage
                                    src={
                                        "https://webb-jenkins-static-164679926.imgix.net/icons/bath.svg"
                                    }
                                    alt="Bath icon"
                                    height={16}
                                    width={24}
                                />
                            </span>

                            <span className="align-text-center">
                                {property.bathrooms} Bathroom
                                {property.bathrooms > 1 && "s"}
                            </span>
                        </div>
                    )}
                </div>
                <p>{property.summary}</p>
                <Row className="mt-5 align-items-bottom">
                    <Col xs={12} md={6} lg={12} xxl={6}>
                        <Col
                            xs={12}
                            as={Button}
                            size="lg"
                            variant="warning"
                            className="px-3 rounded-0"
                            onClick={() => {
                                dispatch(toggleRequestViewingModal(true))
                                dispatch(setRequestViewingProperty(property))
                            }}
                        >
                            <span className="m-0 text-white">
                                Request a viewing
                            </span>
                        </Col>
                    </Col>

                    <Col xs={12} md={6} lg={12} xxl={6}>
                        <Col
                            xs={12}
                            as={Button}
                            size="lg"
                            variant="outline-warning"
                            onClick={toggleShowShare}
                            className="px-3 rounded-0 mt-3 mt-md-0 my-auto"
                        >
                            <span className="m-0 text-warning">
                                Share this property
                            </span>
                        </Col>
                        <Toast show={showShare} onClose={toggleShowShare}>
                            <Toast.Header>
                                <span className="h6 me-auto my-auto">
                                    Where to share
                                </span>
                            </Toast.Header>
                            <Toast.Body className=" d-flex justify-content-between">
                                <EmailShareButton
                                    url={
                                        `${process.env.BASE_URL}properties/` +
                                        property.property_ref
                                    }
                                >
                                    <EmailIcon size={32} />
                                </EmailShareButton>
                                <TwitterShareButton
                                    url={
                                        `${process.env.BASE_URL}properties/` +
                                        property.property_ref
                                    }
                                >
                                    <TwitterIcon size={32} />
                                </TwitterShareButton>
                                <FacebookShareButton
                                    url={
                                        `${process.env.BASE_URL}properties/` +
                                        property.property_ref
                                    }
                                >
                                    <FacebookIcon size={32} />
                                </FacebookShareButton>
                                <FacebookMessengerShareButton
                                    url={
                                        `${process.env.BASE_URL}properties/` +
                                        property.property_ref
                                    }
                                >
                                    <FacebookMessengerIcon size={32} />
                                </FacebookMessengerShareButton>
                                <WhatsappShareButton
                                    url={
                                        `${process.env.BASE_URL}properties/` +
                                        property.property_ref
                                    }
                                >
                                    <WhatsappIcon size={32} />
                                </WhatsappShareButton>
                            </Toast.Body>
                        </Toast>
                    </Col>
                </Row>
            </Card.Body>
        </Col>
        /* Property Summary End */
    )
}

export default PropertySummary
